import { Box, Skeleton } from '@mui/material';

// Add this new component at the top level, outside of NewFaqSetup
const StoreRowSkeleton = () => (
  <Box
    sx={{
      bgcolor: '#fff',
      borderRadius: '6px',
      border: '1px solid',
      borderColor: '#DCE0E7',
      mb: 1,
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: '#5A4CE61A',
      }}
    >
      <Skeleton width={150} height={20} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Skeleton width={50} height={20} />
        <Skeleton width={120} height={34} />
        <Skeleton width={30} height={30} variant="circular" />
      </Box>
    </Box>
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        borderTop: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Skeleton width={180} height={40} />
      <Skeleton width={180} height={40} />
    </Box>
  </Box>
);

export default StoreRowSkeleton;
